import { createCountPopupShowedCookie } from './createCountPopupShowedCookie';
import { getOrCreateHistoryPopupShowedCookie } from './getOrCreateHistoryPopupShowedCookie';

export function incrementCountPopupShowed() {
  const { count, timeStarted } = getOrCreateHistoryPopupShowedCookie();

  createCountPopupShowedCookie(count + 1, timeStarted);
}
